"use strict";

require("./main.scss");

const modalBttns = document.getElementsByClassName("lckModal__action");

const closeModal = function(modal) {
  modal.classList.remove("lckModal--active");
};

const createModal = function(modalId, el) {
  let modal = document.createElement("div");
  modal.id = modalId;
  modal.classList.add("lckModal");
  modal.classList.add("lckModal__holder");
  modal.innerHTML = `<div class="lckModal__container"><div class="lckModal__close">×</div><div class="lckModal__content"></div></div>`;
  if (el.dataset.modalContent) {
    const modalContent = modal.getElementsByClassName("lckModal__content")[0];
    modalContent.innerHTML = decodeURI(el.dataset.modalContent);
  }
  return document.body.appendChild(modal);
};

const lckModalInit = function(e) {
  const el = e.target;
  const modal = document.getElementById(el.dataset.modalId, el)
    ? document.getElementById(el.dataset.modalId)
    : createModal(el.dataset.modalId);
  modal.classList.add("lckModal--active");
  if (!modal.classList.contains("lckModal--inited")) {
    modal.classList.add("lckModal--inited");
    const modalContainer = modal.getElementsByClassName(
      "lckModal__container"
    )[0];
    const modalClose = modalContainer.getElementsByClassName(
      "lckModal__close"
    )[0];
    modal.onclick = modalClose.onclick = function() {
      closeModal(modal);
    };
    modalContainer.onclick = function(event) {
      event.stopPropagation();
    };
  }
};

const modalInit = function() {
  for (let i = 0; i < modalBttns.length; i++) {
    modalBttns[i].onclick = modalBttns[i].dataset.modalId ? lckModalInit : null;
  }
};

modalInit();



// WEBPACK FOOTER //
// ./src/main.js